module.exports = __webpack_public_path__ + "img/invoice.5dfb8d88.png";